<template>
  <div class="module--dashboard_dashboard">
    <div class="loc-select">
      <select @change="updateLoc($event.target.value)">
        <option :value="null">{{ $t("select.all") }}</option>
        <option v-for="loc in locs" :key="loc.loc_id" :value="loc.loc_id">{{ loc.address }}</option>
      </select>
    </div>
    <el-row :gutter="10" style="margin-bottom: 10px">
      <!-- <el-col :span="6">
        <DashBlock v-loading="loading">
        <div class="chart" ref="chart_area">
          <canvas class="energy-chart" ref="energy_chart"></canvas>
        </div>
        </DashBlock>
      </el-col> -->
      <el-col :span="24">
        <div class="cp-summary">
          <div class="site-wrapper">
            <DashBlock
              class="connector-quick-info"
              style="margin-bottom: 10px"
              v-loading="loading"
            >
              <div
                class="count"
                :class="type"
                v-for="type in Object.keys(data.connectors)"
                :key="type"
              >
                <div class="value">{{ data.connectors[type] }}</div>
                <div class="label">{{ $t(`dashboard.status.${type}`) }}</div>
              </div>
            </DashBlock>
            <DashBlock v-if="checkPermissions('Dashboard_summary')" class="summary-wrapper" v-loading="loading">
              <div
                class="summary"
                v-for="day in Object.keys(info.site_usage)"
                :key="day"
              >
                <div class="label">{{ $t(`dashboard.daterange.${day}`) }}</div>
                <div
                  class="charging-time"
                  v-html="getFormatTime(info.site_usage[day].charging_time)"
                ></div>
                <div class="energy">
                  <div class="value">
                    {{ info.site_usage[day].energy / 1000 }}
                  </div>
                  <div class="unit">kWh</div>
                </div>
              </div>
            </DashBlock>
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="cp-wrapper">
      <div class="cp">
        <div class="connector-wrapper">
          <DashBlock class="connector-status-wrap" v-loading="loading">
            <template v-slot:head>
              <div class="head">
                <div class="title">
                  {{ $t("dashboard.label.charging_status") }}
                </div>
                <div class="action">
                  <div class="next">
                    <div class="icon">
                      <fa :icon="['fas', 'list']" />
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <el-row :gutter="10">
              <el-col
                v-for="conn in connectors"
                :key="conn.name"
                :span="6"
                style="margin-bottom: 10px"
                v-show="conn.status"
              >
                <DashBlock class="connector-wrap" :class="conn.status">
                  <template v-slot:head>
                    <router-link class="head" :to="`cps/${conn.cp_id}`">
                      <div class="name">{{ conn.name }}</div>
                      <div class="status" :class="conn.status">
                        <div class="status-wrap">
                          <div class="icon" :title="conn.status"></div>
                          <div class="name">{{ conn.status ? $t(`dashboard.status.${conn.status}`) : "N/A" }}</div>
                        </div>
                        <div class="lupd">{{ conn.status_lupd }}</div>
                      </div>
                    </router-link>
                  </template>
                  <div class="detail">
                    <div class="charging">
                      <div class="current-status" v-show="page.connectors == 0">
                        <div class="used_by">{{ conn.used_by.name }}</div>
                        <!-- row 1 -->
                        <el-row>
                          <el-col class="consumption" :span="12">
                            <div class="label">
                              {{ $t("dashboard.label.consumption") }}
                            </div>
                            <div class="data">
                              <div class="value">
                                {{ typeof conn.used_by.energy_consumed != "undefined" ? (conn.used_by.energy_consumed / 1000) : "---" }}
                              </div>
                              <div class="unit">kWh</div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="label">
                              {{ $t("dashboard.label.time") }}
                            </div>
                            <div
                              class="value"
                              v-html="
                                getFormatTime(
                                  ((conn.used_by.tran_end || ($moment().unix()*1000)) -
                                    conn.used_by.tran_start) / 1000
                                )
                              "
                            ></div>
                          </el-col>
                        </el-row>
                        <!-- row 2 -->
                        <el-row :gutter="2">
                          <el-col :span="8" class="multi-value">
                            <div class="label">
                              {{ $t("dashboard.label.voltage") }}
                            </div>
                            <div class="data">
                              <div
                                class="wrap"
                                v-for="voltage in conn.used_by.voltage"
                              >
                                <div class="value">{{ typeof voltage != "undefined" ? voltage : "---" }}</div>
                                <div class="unit">V</div>
                              </div>
                            </div>
                          </el-col>
                          <el-col :span="8" class="multi-value">
                            <div class="label">
                              {{ $t("dashboard.label.current") }}
                            </div>
                            <div class="data">
                              <div
                                class="wrap"
                                v-for="current in conn.used_by.current"
                              >
                                <div class="value">{{ typeof current != "undefined" ? current : "---" }}</div>
                                <div class="unit">A</div>
                              </div>
                            </div>
                          </el-col>
                          <el-col :span="8">
                            <div class="label">SoC</div>
                            <div class="data">
                              {{ conn.used_by.soc | socUnit }}
                            </div>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12" v-if="conn.used_by.id_tag">
                            <div class="label">{{ $t("field.cp_sessions_all.id_tag") }}</div>
                            <div class="data">
                              <div class="value">{{ conn.used_by.id_tag }}</div>
                            </div>
                          </el-col>
                          <el-col :span="12" v-if="conn.used_by.car_reg_no">
                            <div class="label">{{ $t("field.account_vehicles.car_reg_no") }}</div>
                            <div class="data">
                              <div class="value">{{ conn.used_by.car_reg_no }}</div>
                            </div>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col>
                            <div class="start-time">
                              <div class="label">
                                {{ $t("dashboard.label.start_from") }}
                              </div>
                              <div class="value">
                                {{
                                  conn.used_by.tran_start
                                    ? $moment(conn.used_by.tran_start).format(
                                        "YYYY-MM-DD HH:mm:ssa"
                                      )
                                    : ""
                                }}
                              </div>
                            </div>
                          </el-col>
                        </el-row>
                        <!-- tran_end -->
                        <el-row v-if="conn.used_by.tran_end">
                          <el-col>
                            <div class="start-time">
                              <div class="label">
                                {{ $t("dashboard.label.end_on") }}
                              </div>
                              <div class="value">
                                {{
                                  conn.used_by.tran_end
                                    ? $moment(conn.used_by.tran_end).format(
                                        "YYYY-MM-DD HH:mm:ssa"
                                      )
                                    : ""
                                }}
                              </div>
                            </div>
                          </el-col>

                        </el-row>
                          <el-row>
                              <el-col>
                                  <div class="start-time">
                                      <div class="label">
                                          <div class="label">{{ $t("dashboard.label.bayStatus") }}</div>
                                      </div>
                                      <div class="value">
                                          {{conn.bayStatus}}
                                      </div>
                                  </div>
                              </el-col>
                          </el-row>


                        <!-- end -->
                      </div>
                      <div class="summary" v-show="page.connectors == 1">
                        <div class="title">
                          {{ $t("dashboard.label.usage") }}
                        </div>
                        <el-row>
                          <el-col :span="12" v-if="conn.used_by">
                            <div class="label">
                              {{ $t("dashboard.daterange.today") }}
                            </div>
                            <div class="energy">
                              <div class="value">
                                {{
                                  conn.used_by.summary
                                    ? conn.used_by.summary.today.energy / 1000
                                    : 0
                                }}
                              </div>
                              <div class="unit">kWh</div>
                            </div>
                            <div class="charging-time">
                              <div
                                class="value"
                                v-html="
                                  getFormatTime(
                                    conn.used_by.summary
                                      ? conn.used_by.summary.today.charging_time
                                      : 0
                                  )
                                "
                              ></div>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="label">
                              {{ $t("dashboard.daterange.weekly") }}
                            </div>
                            <div class="energy">
                              <div class="value">
                                {{
                                  conn.used_by.summary
                                    ? conn.used_by.summary.weekly.energy / 1000
                                    : 0
                                }}
                              </div>
                              <div class="unit">kWh</div>
                            </div>
                            <div class="charging-time">
                              <div
                                class="value"
                                v-html="
                                  getFormatTime(
                                    conn.used_by.summary
                                      ? conn.used_by.summary.weekly
                                          .charging_time
                                      : 0
                                  )
                                "
                              ></div>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                    <!-- <div class="not-in-use" v-else>
                      <div class="message">
                        {{ $t("dashboard.label.not_in_use") }}
                      </div>
                    </div> -->

                    <div class="icon">
                      <fa
                        :icon="['fas', 'charging-station']"
                        @click="flipPage"
                      />
                    </div>
                  </div>
                </DashBlock>
              </el-col>
            </el-row>
          </DashBlock>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import DashBlock from "@/components/modules/dashboard/DashBlock";
import "@/utils/chartjs-doughnut-inner-text.js";
import { mapState } from 'vuex';

export default {
  components: {
    DashBlock,
  },
  async mounted() {
    this.loading = true;
    this.fetchData();
    this.iid = setInterval(this.fetchData, 1000 * 60);
    this.loading = false;
  },
  computed: {
    ...mapState({
      permissions: state => state.user.user_info.permissions
    }),
  },
  methods: {
    checkPermissions(str){
      return this.permissions.includes(`READ_${str}`.toUpperCase());
    },
    async fetchData() {
      await this.$axios.get("/quick_info",{
        params: {
          loc_id: this.selected_loc_id
        }
      }).then((res) => {
        this.info = res.data.response.info;
      });

      this.locs = this.info.refs.cp_locs;
      // acc
      Object.keys(this.info.acc_charging_status).map((acc_id) => {
        let acc = this.info.acc_charging_status[acc_id];
        console.log("acc: ", acc);
        if (acc.hasOwnProperty("connector_id")) {
          if(this.info.cp_status[acc.cp_id] != undefined){
            this.info.cp_status[acc.cp_id].connector_used_by =
              this.info.cp_status[acc.cp_id].connector_used_by || {};
            this.info.cp_status[acc.cp_id].connector_used_by[acc.connector_id] =
              acc;
            console.log("cp status: ", this.info.cp_status[acc.cp_id]);
          }
        }
      });
      // cp
      // Object.keys(this.info.refs.cp_connectors).map((cp_id) => {
      //   let connectors = this.info.refs.cp_connectors[cp_id];
      //   this.info.cp_status[cp_id].connector_used_by =
      //     this.info.cp_status[cp_id].connector_used_by || {};
      //   connectors.map((conn) => {
      //     console.log(`${cp_id}-${conn}`);
      //     // status
      //     if (this.info.cp_status[cp_id].connector_status[conn]) {
      //       this.setStatus(
      //         this.info.cp_status[cp_id].connector_status[conn].status
      //       );
      //     }
      //     // combine connectors
      //     if (this.info.refs.cps.hasOwnProperty(cp_id)) {
      //       let cp = this.info.refs.cps[cp_id];
      //       let status_lupd = this.info.cp_status[cp_id].connector_status[conn] ? this.info.cp_status[cp_id].connector_status[conn].connector_status_last_updated_dt : null;
      //       this.connectors.push({
      //         name: `${cp.cp_no} - ${conn}`,
      //         cp_id: cp.cp_id,
      //         status: this.info.cp_status[cp_id].connector_status[conn]
      //           ? this.info.cp_status[cp_id].connector_status[conn].status
      //           : "na",
      //           status_lupd,
      //         used_by: this.info.cp_status[
      //           cp_id
      //         ].connector_used_by.hasOwnProperty(conn)
      //           ? this.info.cp_status[cp_id].connector_used_by[conn]
      //           : {},
      //       });
      //     }
      //   });
      // });

let connectorsArr = [];
      this.data.connectors.Charging = 0;
      this.data.connectors.Available = 0;
      this.data.connectors.Unavailable = 0;
      Object.keys(this.info.refs.cp_connectors).map(cp_id=>{
        let connectors = this.info.refs.cp_connectors[cp_id];
        
        this.info.cp_status[cp_id].connector_used_by = this.info.cp_status[cp_id].connector_used_by || {};
        connectors.map(conn=>{
          console.log(`${cp_id}-${conn}`);
          // status
          if (this.info.cp_status[cp_id].connector_status[conn]) {
            let status = this.info.cp_status[cp_id].connector_status[conn].status;
            if(status == "Offline") status = "Unavailable";
            this.setStatus(status);
          }
          // combine connectors
          if(this.info.refs.cps.hasOwnProperty(cp_id)) {
            let cp = this.info.refs.cps[cp_id];
            let status_lupd = this.info.cp_status[cp_id].connector_status[conn] ? this.info.cp_status[cp_id].connector_status[conn].connector_status_last_updated_dt : null;
            connectorsArr.push({
              name: `${cp.cp_no} - ${conn}`,
              cp_id: cp.cp_id,
              status: this.info.cp_status[cp_id].connector_status[conn]
                ? this.info.cp_status[cp_id].connector_status[conn].status
                : "na",
              status_lupd: status_lupd != null ? this.$moment(status_lupd).format("yyyy-MM-DD HH:mm:ss"): "",
              used_by: this.info.cp_status[cp_id].connector_used_by.hasOwnProperty(conn) ? this.info.cp_status[cp_id].connector_used_by[conn] : {},
              bay: this.info.cp_status[cp_id].connector_status[conn].bay? this.info.cp_status[cp_id].connector_status[conn].bay: "",
                bayStatus: this.info.cp_status[cp_id].connector_status[conn].bayStatus? this.info.cp_status[cp_id].connector_status[conn].bayStatus: "",
              bayLupdDttm: this.info.cp_status[cp_id].connector_status[conn].bayLupdDttm? this.info.cp_status[cp_id].connector_status[conn].bayLupdDttm: "",
            })
          }
        });
      });
      this.connectors = connectorsArr;

      // pie chart
      // var ctx = this.$refs.energy_chart;
      // console.log("width: ",this.$refs.chart_area.offsetWidth);
      // // ctx.width = this.$refs.chart_area.offsetWidth;
      // ctx.height = document.querySelectorAll(".el-row")[0].offsetHeight + 25;
      // // ctx.height = 100;
      // this.chart = new Chart(ctx, {
      //   type: 'doughnut',
      //   data: {
      //     labels: [
      //       this.$t("dashboard.label.used"),
      //       this.$t("dashboard.label.not_used"),
      //     ],
      //     datasets: [
      //       {
      //         backgroundColor: ["#98FB98", "#CCCCCC"],
      //         // weight: [1, .5],
      //         data: [
      //           this.info.site_usage.today.energy,
      //           20000 - this.info.site_usage.today.energy
      //         ]
      //       },
      //     ]
      //   },
      //   options: {
      //     cutoutPercentage: 70,
      //     elements: {
      //       center: {
      //         text: this.info.site_usage.today.energy/1000 + " kWh",
      //         // color: '#FF6384', // Default is #000000
      //         fontStyle: 'Arial', // Default is Arial
      //         sidePadding: 20, // Default is 20 (as a percentage)
      //         minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
      //         lineHeight: 25 // Default is 25 (in px), used for when text wraps
      //       }
      //     }
      //   }
      // });
      // this.chart.render;
    },
    setStatus(val) {
      switch (val) {
        case "Charging":
          this.data.connectors.Charging++;
          break;
        case "Available":
          this.data.connectors.Available++;
          break;
        case "Unavailable":
          this.data.connectors.Unavailable++;
          break;
      }
    },
    flipPage() {
      if (this.page.connectors == 0) {
        this.page.connectors = 1;
      } else {
        this.page.connectors = 0;
      }
    },
    updateLoc(loc_id) {
      this.selected_loc_id = loc_id;
      this.fetchData();
      console.log("loc_id: ", loc_id);
    }
  },
  filters: {
    socUnit(value) {
      return value ? `${value}%` : "---";
    },
  },
  data() {
    return {
      chart: {},
      loading: false,

      locs: [],
      selected_loc_id: null,
      info: {
        acc_charging_status: {},
        cp_status: {},
        cp_usage: {},
        site_usage: {
          today: {
            energy: 0,
          },
        },
        refs: {
          cp_connectors: {},
          cps: {},
        },
      },

      data: {
        connectors: {
          Charging: 0,
          Available: 0,
          Unavailable: 0,
        },
      },

      connectors: [],

      page: {
        connectors: 0,
      },
    };
  },
};
</script>

<style lang="scss">
.module--dashboard_dashboard {
  height: 100%;
  min-width: 1024px;
  .loc-select{
    margin-bottom: 10px;
    text-align: right;
    select{
      height: 30px;
      line-height: 30px;
    }
  }
  .cp-summary {
    .site-wrapper {
      .connector-quick-info {
        .content {
          display: flex;
          .count {
            // display: flex;
            width: 100%;
            text-align: center;
            .value {
              font-size: 30px;
              margin-right: 10px;
              display: inline-block;
            }
            .label {
              font-size: small;
              display: inline-block;
              vertical-align: text-bottom;
            }
            &.Charging > .value {
              color: orange;
            }
            &.Available > .value {
              color: #3fff00;
            }
            &.Unavailable > .value {
              color: red;
            }
          }
        }
      }
      .summary-wrapper {
        .content {
          display: flex;
          .summary {
            width: 100%;
            text-align: center;
            .label {
              font-size: large;
              margin-bottom: 15px;
            }
            .energy,
            .charging-time {
              // display: flex;
              .wrap {
                // display: flex;
                display: inline-block;
              }
              .value {
                font-size: 30px;
                display: inline-block;
              }
              .unit {
                font-size: small;
                display: inline-block;
                color: #aaa;
              }
            }
            .energy {
              .value {
                margin-right: 5px;
              }
            }
          }
        }
      }
    }
  }
  .cp-wrapper {
    .connector-wrapper {
      .connector-status-wrap {
        .el-col-6 {
          // min-width: 230px;
        }
        & > .head {
          display: flex;
          justify-content: space-between;
          padding: 7px 10px;
          .action {
            .next {
              color: white;
              background: #414e75;
              width: 25px;
              height: 25px;
              border-radius: 3px;
              cursor: pointer;
              .icon {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
              }
            }
          }
        }
      }
      .el-row {
        .el-col {
          .connector-wrap {
            height: 195px;
            &.Offline{
              opacity: .5;
            }
            .head{
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 2px 10px;
              background: #414e75;
              color: white;
              border-top-left-radius: 5px;
              border-top-right-radius: 5px;
              text-decoration: none;
              height: 35px;
              .name{
                // font-size: small;
                font-size: 14px;
              }
              .lupd{
                font-size: 12px;
                color: white;
                zoom: .9;
              }
              .status{
                display: flex;
                flex-direction: column;
                justify-items: center;
                align-items: flex-end;
                .status-wrap{
                  display: flex;
                  align-items: center;
                }
                &.Unavailable{
                  color: red;
                  .icon{
                    background: red;
                  }
                }
                &.Available{
                  color: #3fff00;
                  .icon{
                    background: #3fff00;
                  }
                }
                &.Charging{
                  color: dodgerblue;
                  .icon{
                    background: dodgerblue;
                  }
                }
                &.Offline{
                  color: #ccc;
                  .icon{
                    background: #ccc;
                  }
                }
                .icon{
                  height: 12px;
                  width: 12px;
                  border-radius: 50%;
                  margin-right: 2px;
                  // border: 1px solid #f9f9f9;
                  background: yellow;
                }
                .name{
                  font-size: x-small;
                }
                .label{
                  font-size: small;
                }
              }
            }
            .content {
              padding: 5px 10px;
              .detail {
                height: 100%;
                position: relative;
                [class*=el-col-]{
                  line-height: 1.3;
                }
                & > .icon {
                  position: absolute;
                  bottom: 0;
                  right: 0;
                  color: #d9d9d9;
                }
                .used_by {
                  // font-size: 14px;
                }
                .label {
                  font-size: x-small;
                  font-weight: bold;
                }
                .data {
                  // display: flex;
                  // flex-wrap: wrap;
                  line-height: 1.2;
                  .wrap {
                    display: inline-block;
                    .value {
                    }
                  }
                }
                .multi-value {
                  .data {
                    .wrap {
                      &:not(:last-child)::after {
                        content: "/";
                        font-size: x-small;
                        margin-left: 2px;
                        margin-right: 2px;
                      }
                    }
                  }
                }
                .value {
                  display: flex;
                }
                .data,
                .value > .wrap {
                  .value {
                    display: inline-block;
                    font-size: small;
                    // font-size: large;
                  }
                  .unit {
                    display: inline-block;
                    font-size: x-small;
                  }
                }

                .not-in-use {
                  height: 100%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 35px;
                  color: #d9d9d9;
                }
                .start-time {
                  .label {
                    display: inline-block;
                    margin-right: 5px;
                  }
                  .value {
                    font-size: small;
                    display: inline-block;
                  }
                }
                .charging {
                  height: 100%;
                  & > .summary {
                    height: 100%;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    // align-items: center;
                    justify-content: center;
                    .title {
                      font-weight: normal;
                    }
                    .label {
                      font-weight: normal;
                    }
                    .value {
                      justify-content: center;
                    }
                    .energy {
                      .value,
                      .unit {
                        display: inline-block;
                      }
                      .unit {
                        font-size: x-small;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>